// Warenkorb für die Lampenschirm-Seiten: gleiche Route und gleiches CartAddEvent wie Horizons product-form,
// damit Drawer (auto-open) und Warenkorb-Zähler im Header reagieren wie auf den übrigen Produktseiten.
import { CartAddEvent } from '@theme/events';

const addUrl = () => (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

async function addToCart(button) {
  const variantId = button.dataset.variantId;
  const status = document.getElementById(button.getAttribute('aria-describedby'));
  if (!variantId || button.disabled) return;
  const label = button.textContent;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  button.textContent = 'Wird hinzugefügt …';
  if (status) status.textContent = '';
  try {
    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    const sectionIds = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
    if (sectionIds.length) body.append('sections', sectionIds.join(','));
    const response = await fetch(addUrl(), { method: 'POST', body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Der Artikel konnte nicht hinzugefügt werden.');
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).catch(() => undefined);
    document.dispatchEvent(new CartAddEvent(cart, String(variantId), {
      source: 'product-form-component',
      itemCount: 1,
      productId: button.dataset.productId,
      variantId: String(variantId),
      sections: data.sections,
    }));
    button.textContent = 'Im Warenkorb ✓';
    if (status) status.innerHTML = 'Hinzugefügt. <a href="/cart">Zum Warenkorb</a>';
    setTimeout(() => { button.textContent = label; button.disabled = false; button.removeAttribute('aria-busy'); }, 2200);
  } catch (error) {
    button.textContent = label;
    button.disabled = false;
    button.removeAttribute('aria-busy');
    if (status) status.textContent = error.message;
  }
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('#lunatre-shades [data-shade-add]');
  if (button) { event.preventDefault(); addToCart(button); }
});
